// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductCate_wrapper__+pqPC","header":"ProductCate_header__yiHnf","category":"ProductCate_category__n7d+E","cate-item":"ProductCate_cate-item__kmwra"};